import React from 'react';
import SellerRouter, { sellerRouterRoutes } from './subrouters/Seller';
import BuyerRouter, { buyerRouterRoutes } from './subrouters/Buyer';
import { RoutingStep } from 'router/models/Routes';
import { Navigate } from 'react-router';
import {
  SELLER_PATH,
  SELLER_LABEL,
  BUYING_PATH,
  BUYING_LABEL,
  BOSS_MODE_PATH,
} from 'data/global';
import RedirectBossModeRouter from './subrouters/RedirectBossModeRouter';

export default [
  {
    path: SELLER_PATH,
    element: SellerRouter,
    labelId: SELLER_LABEL,
    stepName: SELLER_LABEL,
    routes: sellerRouterRoutes,
  },
  {
    path: BUYING_PATH,
    element: BuyerRouter,
    labelId: BUYING_LABEL,
    stepName: BUYING_LABEL,
    routes: buyerRouterRoutes,
  },
  {
    path: `${BOSS_MODE_PATH}/*`,
    element: RedirectBossModeRouter,
  },
  { index: true, element: <Navigate to={SELLER_PATH} replace /> },
] as Array<RoutingStep>;
